import React, { useCallback, useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { createInvoice } from '../../actions'
import InvoiceItem from './InvoiceItem'
import { useEvent } from '../../hooks/useEvent'
import { CustomLoader } from '../../../commonComponents/formComponents/loader'
import { SAVE_ITEM_CDS } from '../../api/apiEvents'
import { AddBtn } from '../../../commonComponents/AddBtn'
import { useValidationCDS } from '../../hooks/useValidationCDS' //
import AccordionInvoice from '@commonComponents/accordion/AccordianInvoice'


export const InvoiceList = React.memo(({ dataSource, renderItem }) => dataSource.map(renderItem))

export const InvoiceForm = ({ isFormEnabled }) => {
  const dispatch = useDispatch()
  const { isLoading, saveForm } = useEvent('invoice', true)
  

  const { validateError, initItemsTabValidationCDS } = useValidationCDS('items') 

  const invoiceIds = useSelector((state) => state.InvoicesReducer.invoice.invoiceIds)
  const { incoterms } = useSelector((state) => state.Shipment.transportation.deliveryTerms)

  const getInvoiceId = useCallback(async () => {
    const response = await saveForm(
      { invoiceList: { '': { header: { incoTerms: incoterms || '' } } } },
      true,
      SAVE_ITEM_CDS
    )
    if (response) {
      const invoiceId = Object.keys(response.invoice.invoiceList)[0]
      dispatch(createInvoice(invoiceId, response.invoice.invoiceList[invoiceId].header))
    }
  }, [dispatch, saveForm])

  return (
    <React.Fragment>
      {
        invoiceIds.length>0 && 
       <AccordionInvoice
         initialiState={{[invoiceIds?.[0]]:true}}
         keyName={"toggleInvoices"} 
         expandTitle={"OPEN_ALL_INVOICES"}
         collapseTitle={"CLOSE_ALL_INVOICES"}
         >
        {
          invoiceIds.map((invoiceId,invoiceItemIndex)=>{
            return (
              <div className='mb-2'
               key={`invoice${invoiceId}`}
               id={invoiceId}
               >
                <InvoiceItem
                  invoiceId={invoiceId}
                  isFormEnabled={isFormEnabled}
                  invoiceItemIndex={invoiceItemIndex}
                  validateError={validateError}
                  initItemsTabValidationCDS={initItemsTabValidationCDS}
                />
              </div>
            )
          })
        }
   
     </AccordionInvoice>
      }
     

      {isLoading && <CustomLoader />}

      <AddBtn
        style={{ marginTop: '10px' }}
        onClick={getInvoiceId}
        id='addInvoice'
        text='Add Invoice'
        iconClass=''
      ></AddBtn>
    </React.Fragment>
  )
}

export default React.memo(InvoiceForm)
